
  
    <div class="blog-navigation-not-sticky" >
      <button class="nav-btn prev" *ngIf="hasPrev" (click)="goTo(-1)">
        {{'BLOG.NAVIGATION.PREV' | translate }}
      </button>
    
      <button class="nav-btn next" *ngIf="hasNext" (click)="goTo(1)">
        {{'BLOG.NAVIGATION.NEXT' | translate }}
      </button>
      </div>
  <markdown [data]="markdownContent" class="markdown-body"></markdown>

  <div class="blog-cta">
    <h2> {{'BLOG.CTA_TITLE' | translate }}</h2>
    <p> {{'BLOG.CTA_TEXT' | translate }}</p>
    <a class="cta-button" href="/#contact"> {{'BLOG.CTA_BUTTON' | translate }}</a>
  </div>

  <div class="blog-navigation" >
    <button class="nav-btn prev" *ngIf="hasPrev" (click)="goTo(-1)">
      {{'BLOG.NAVIGATION.PREV' | translate }}
    </button>
  
    <button class="nav-btn next" *ngIf="hasNext" (click)="goTo(1)">
      {{'BLOG.NAVIGATION.NEXT' | translate }}
    </button>
  </div>
  